let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("diVuB")).then(() => parcelRequire('iKUFL'));